/**
 * CSV 序列化（阶段 7 / §28，纯函数、可单测）。
 *
 * 规则：RFC 4180 口径——值含逗号/引号/换行时用双引号包裹，内部引号翻倍；
 * 空数据集输出 "# (空)" 段注释；列顺序由调用方给定（保证导出稳定）。
 * 服务端（export-data Edge Function）与客户端（本地导出）共用本实现，避免双实现漂移。
 */

export type CsvRecord = Record<string, unknown>;

export function escapeCsvCell(value: unknown): string {
  const s = value == null ? "" : String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** 由表头 + 行数组生成 CSV 字符串。 */
export function rowsToCsv(headers: readonly string[], rows: readonly CsvRecord[]): string {
  if (rows.length === 0) return "# (空)";
  const headerLine = headers.join(",");
  const body = rows.map((r) => headers.map((h) => escapeCsvCell(r[h])).join(","));
  return [headerLine, ...body].join("\n");
}

/** 多数据集 CSV 拼接（每段带表头注释行，便于人读与程序分节）。 */
export function sectionsToCsv(sections: ReadonlyArray<{ title: string; headers: readonly string[]; rows: readonly CsvRecord[] }>): string {
  return sections
    .map((s) => `# === ${s.title} ===\n${rowsToCsv(s.headers, s.rows)}`)
    .join("\n\n");
}